import AppDropdownItem from '@/components/AppDropdownItem.vue';
export default {
  name: 'AppDropdownPartitionTitle',
  components: {
    AppDropdownItem
  }
};